
import Component from "vue-class-component"
import Vue from "vue"
import {Prop} from "vue-property-decorator"
import _ from "lodash"
import {PageSection, PCReport, ReportPage, SectionItem} from "@/report/PCReport"
import {Snapshot} from "@/report/PlanAnalytics"
import {DateRange} from "@/DateRangeSelector"
import {MetricStore} from "@/cube/metric-data/MetricStore"
import {parseISO, startOfMonth} from "date-fns"

export class Chart {
  name: string
  title: string | null = null
  trendHighlight = false
  color: string | null = null

  constructor(name: string, title: string | null = null) {
    this.name = name
    this.title = title
  }
}

export class Table {
  name: string
  title: string | null = null

  constructor(name: string, title: string | null = null) {
    this.name = name
    this.title = title
  }
}

@Component
export default class AbstractPage extends Vue {
  @Prop({required: true})
  report: PCReport

  @Prop({required: true})
  number: number

  @Prop({required: true})
  name: string

  @Prop({default: false})
  engagedOnly: boolean

  metricStore: MetricStore
  dateRange: DateRange

  created() {
    this.metricStore = new MetricStore(this.engagedOnly)
    this.dateRange = {
      start: parseISO(String(this.report.reportingStartDate)),
      end: startOfMonth(parseISO(String(this.report.reportingEndDate))),
    }
  }

  async mounted() {
    this.$nextTick(() => {
      void this.metricStore!.update(this.report.planId!, this.dateRange)
    })
  }

  protected getChart(name: string, title: string | null = null): Chart {
    return new Chart(name, title)
  }

  protected getTable(name: string, title: string | null = null): Table {
    return new Table(name, title)
  }

  protected getReportPage(): ReportPage {
    return this.report.reportPages.find(
      p => p.templatePageNumber === this.number
    )!
  }

  protected getPageSection(section: number): PageSection {
    return this.getReportPage().pageSections.find(s => s.sequence === section)!
  }

  protected getSectionItem(section: number, item: number): SectionItem {
    return this.getPageSection(section).sectionItems.find(
      i => i.sequence === item
    )!
  }

  get lastSnapshot(): Snapshot {
    return _.last(this.report.planAnalytics.snapshots)!
  }
}
